// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getPaymentTypeCode } from '@tectonics/prs/incoming-payment';
import { Separator } from '../../../atoms';
import { Capitalize } from '../commons/render-helpers';

export function ArgentineCashInformation(): Node {
  return (
    <>
      <PaymentLocation />
    </>
  );
}

function PaymentLocation(): Node {
  const incomingPayment = useIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);

  if (paymentTypeCode === 'rapipago') {
    return (
      <>
        <h1>Donde pagar</h1>
        Para realizar tu pago, presenta este cupón en cualquer sucursal <Capitalize>{paymentTypeCode}</Capitalize><br />
        <img height="40em" src={`https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/${paymentTypeCode}/logo.png`} alt={paymentTypeCode} />
      </>
    );
  }

  return (
    <>
      Para realizar tu pago, presenta este cupón en: <b>PagoFacil, RapiPago, CobroExpress, BaproPagos, ProvinciaPagos, ProntoPago, FormoPagos, PagoListo,
      PampaPagos</b> o <b>ChubutPagos</b> para realizar su pago.
      <Separator direction="vertical" size={4} />
      <RenderPaymentMethodImages />
      <Separator direction="vertical" size={4} />
      Alternativamente, puedes pagar tu cupón en línea, con LinkPagos,
      usando el botón abajo.
      <br />
      <a target="_blank" href=" https://www.cuentadigital.com/apilink.php?cpe=42795087">
        <img height="40em" src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/img/linkpagos.png" alt="linkpagos"/>
      </a>
    </>
  );
}

function RenderPaymentMethodImages(): Node {
  const incomingPayment = useIncomingPayment();
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);
  if (paymentTypeCode === 'pagofacil') {
    return (
      <>
        <img height="40em" src={`https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/${paymentTypeCode}/logo.png`} alt={paymentTypeCode} />
      </>
    );
  }

  return (
    <>
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/pagofacil.png" alt="PagoFacil" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/rapipago.jpg" alt="Rapipago" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/cobroexpress.jpg" alt="CobroExpress" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/bapro@3x.png" alt="BaproPagos" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/provincia-pagos@2x.png" alt="ProvinciaPagos" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/prontopago.jpg" alt="ProntoPagos" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/formopagos@3x.png" alt="FormoPagos" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/pagolisto@2x.png" alt="Pagolisto" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/pampapagos@3x.png" alt="PampaPagos" />
      <Image src="https://s3-sa-east-1.amazonaws.com/assets.ebanx.com/gateway/smilewallet/img/logos/color/chubut@3x.jpg" alt="ChubutPagos" />
    </>
  );
}

const Image = styled.img`
  border: 1px solid #dddddd;
  width: 90px;
  height: 38px;
  object-fit: contain;
  border-radius: 5px;
`;
